import { LogsService } from '@gtpl/shared-services/user-logs';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { Module } from '@nestjs/common';
import { TypeOrmModule } from '@nestjs/typeorm';
import { EndCustomersModule } from '../end-customer/end-customer.module';
import { FoodTypesModule } from '../food-types/food-types.module';
import { ItemCategoriesModule } from '../item-categories/item-categories.module';
import { ItemCategoriesService } from '../item-categories/item-categories.service';
import { ItemSubCategoriesModule } from '../item-sub-categories/item-sub-categories.module';
import { ItemVariantModule } from '../item-varient/item-variant.module';
import { MasterBrandsModule } from '../master-brands/master-brands.module';
import { ProductsModule } from '../products/products.module';
import { SizesModule } from '../sizes/sizes.module';
import { SkuCodesModule } from '../sku-codes/sku-codes.module';
import { UomsModule } from '../uoms/uoms.module';
import { ValueAddition1TypesModule } from '../value-addition1-types/value-addition1-types.module';
import { ValueAddition2TypesModule } from '../value-addition2-types/value-addition2-types.module';
import { ValueAddition3TypesModule } from '../value-addition3-types/value-addition3-types.module';
import { ValueAddition4TypesModule } from '../value-addition4-types/value-addition4-types.module';
import { ValueAddition5TypesModule } from '../value-addition5-types/value-addition5-types.module';
import { ItemAdapter } from './dto/item.adapter';
import { Item } from './item.entity';
import { ItemsController } from './items.controller';
import { ItemsService } from './items.service';
@Module({
  imports: [
    TypeOrmModule.forFeature([Item]),
    SizesModule,
    SkuCodesModule,
    UomsModule,
    ProductsModule,
    MasterBrandsModule,
    EndCustomersModule,
    ItemCategoriesModule,
    ItemSubCategoriesModule,
    FoodTypesModule,
    ValueAddition1TypesModule,
    ValueAddition2TypesModule,
    ValueAddition3TypesModule,
    ValueAddition4TypesModule,
    ValueAddition5TypesModule
  ],
  controllers: [ItemsController],
  providers: [ItemsService,ItemAdapter,ApplicationExceptionHandler,LogsService]
})
export class ItemsModule {}
